import { render, staticRenderFns } from "./BaseButtonSmallRed.vue?vue&type=template&id=ee99fbea&scoped=true&"
import script from "./BaseButtonSmallRed.vue?vue&type=script&lang=js&"
export * from "./BaseButtonSmallRed.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonSmallRed.vue?vue&type=style&index=0&id=ee99fbea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee99fbea",
  null
  
)

export default component.exports